import type { RecognitionResult } from '../types/file-upload';

/**
 * 第二阶段：文件识别服务接口
 */
export interface FileRecognitionService {
    /**
     * 识别文件内容
     * @param params 识别参数
     * @param params.fileId 服务器端文件ID
     * @param params.contentType 文件内容类型
     * @param onProgress 进度回调函数
     * @returns 识别结果
     */
    recognize(params: { fileId: string; contentType: 'DISCLOSURE' | 'CLAIM' }, onProgress?: (progress: number) => void): Promise<RecognitionResult>;
}

/**
 * 文件识别服务绑定标识
 */
export const FileRecognitionService = Symbol.for('FileRecognitionService');
